/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import{isGeographic as e,isWebMercator as t}from"../../geometry/support/spatialReferenceUtils.js";const r=1e5;function o(r){return e(r)||t(r)?0:1}export{o as autoMeasurementMode,r as geodeticDistanceThresholdMeters};
